"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addTracingExtensions = addTracingExtensions;

var _errors = require("./errors.js");

/**
 * @deprecated Use `registerSpanErrorInstrumentation()` instead. In v9, this function will be removed. Note that you don't need to call this in Node-based SDKs or when using `browserTracingIntegration`.
 */
function addTracingExtensions() {
  (0, _errors.registerSpanErrorInstrumentation)();
}